import React from 'react';
import CategoryMainComponent from '../components/categories/CategoryMain.Component';

const CategoryMainPageComponent = () => {
  return <CategoryMainComponent />;
};

export default CategoryMainPageComponent;
